export const isNullOrWhitespace = (input: string | null | undefined): boolean =>
  input === null || input === undefined || /^\s*$/.test(input);
